module.exports = __webpack_public_path__ + "static/img/Fancl.5e3e427.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/Fancl.jpg
// module id = HLS+
// module chunks = 0